// extracted by mini-css-extract-plugin
export default {"game-instructions":"GameInstructions_game-instructions__6nfES","game-instructions__directions":"GameInstructions_game-instructions__directions__iAspv"};